import { render } from "./NewParkingLots.vue?vue&type=template&id=471f6923&scoped=true"
import script from "./NewParkingLots.vue?vue&type=script&lang=js"
export * from "./NewParkingLots.vue?vue&type=script&lang=js"

import "./NewParkingLots.vue?vue&type=style&index=0&id=471f6923&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471f6923"]])

export default __exports__